import React, { useState, useEffect } from "react";
import axios from "axios";
import MainNavbar from "../component/navbar/Navbar";
import styles from "./styles/turningPage.module.css";

const TurningPage = () => {
  const [turn, setTurn] = useState("");

  const callTurn = () => {
    axios
      .get("http://192.168.11.11:3000/api/device/caller/last-number")
      .then((res) => {
        setTurn(res.data.data.number);
        console.log(res.data.data.number);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    callTurn();
  }, []);

  return (
    <div>
      <MainNavbar />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="text-center mt-5">
              <div className={styles.mainContainerBox}>
                <h1> نوبت فراخوانی شده </h1>
                <div className={styles.turningContainer}>
                  <p className={styles.turningNumber}>
                    {turn ? turn.number : "هنوز نوبتی فراخوانی نشده است"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TurningPage;
